import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    DateField,
    ReferenceField,
    EditButton,
    Filter,
    SearchInput,
    SimpleList,
} from 'react-admin';
import { useMediaQuery } from '@material-ui/core';

const ProductFilter = (props: any) => (
    <Filter {...props} variant="outlined">
        <SearchInput label="Code" source="code~like" alwaysOn />
        <SearchInput label="Product Name" source="productName~like" alwaysOn />
    </Filter>
);

export const ProductList = (props: any) => {
    const propsObj: any = { ...props };
    const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    debugger
    if (propsObj.permissions) {
        const resourcename = `/${props.resource}`;
        const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
        if (myPermissions.length > 0) {
            const p = myPermissions[0];
            propsObj.hasList = p.View === 1;
            propsObj.hasShow = p.View === 1;
            propsObj.hasEdit = p.Edit === 1;
            propsObj.hasDelete = p.Delete === 1;
            propsObj.hasCreate = p.Create === 1;
            propsObj.hasExport = p.Export === 1;
        }
    }

    return (
        <React.Fragment>
            <List
                {...propsObj}
                exporter={propsObj.hasExport}
                bulkActionButtons={false}
                title="Products"
                filters={<ProductFilter />}
            >
                {isSmall ? (
                    <SimpleList
                        primaryText={(record: any) => `${record.code || ''} - ${record.productName || ''}`}
                        secondaryText={(record: any) =>
                            record.rate != null ? `Rate: ${record.rate}` : ''
                        }
                        // tertiaryText={(record: any) =>
                        //     record.createdDate ? `Created: ${new Date(record.createdDate).toLocaleDateString()}` : ''
                        // }
                        linkType={propsObj.hasEdit ? 'edit' : 'show'}
                    />
                ) : (
                    <Datagrid rowClick={propsObj.hasEdit ? 'edit' : undefined}>
                        {propsObj.hasEdit && <EditButton />}
                        <TextField source="code" label="Code" />
                        <TextField source="productName" label="Product Name" />
                        <ReferenceField source="groupId" reference="product-groups" label="Product Group" link={false}>
                            <TextField source="designName" />
                        </ReferenceField>
                        
                    </Datagrid>
                )}
            </List>
        </React.Fragment>
    );
};
